import { render, staticRenderFns } from "./FrameRenderer.vue?vue&type=template&id=466b4f2c&scoped=true&"
import script from "./FrameRenderer.vue?vue&type=script&lang=js&"
export * from "./FrameRenderer.vue?vue&type=script&lang=js&"
import style0 from "./FrameRenderer.vue?vue&type=style&index=0&id=466b4f2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466b4f2c",
  null
  
)

export default component.exports